export const OPEN_PROBLEM = 'open problem';
export const PROBLEM_OPENED = 'problem opened';
export const SOLUTIONS_DOWNLOADED = 'solutions downloaded';
export const NO_SUBSCRIPTION = 'no subscription';
export const TOGGLE_SOLUTION = 'toggle solution';
export const OPEN_ALL_SOLUTIONS = 'open all solutions';
export const CLOSE_ALL_SOLUTIONS = 'close all solutions';
export const NO_PROBLEM = 'no problem';
export const NO_ACCESS = 'problem no access';
export const ACCOUNT_FLAGGED = 'account flagged';
export const LIMIT_EXCEEDED = 'problem limit exceeded';
export const UNKNOWN_ERROR = 'problem unknown error';

export const TOGGLE_COMMENTS = 'toggle comments';
export const POST_COMMENT = 'post comment';
export const COMMENT_POSTED = 'comment posted';
export const POST_COMMENT_ERROR = 'post comment error';
export const REMOVE_COMMENT = 'remove comment';
export const COMMENT_REMOVED = 'comment removed';
export const REMOVE_COMMENT_ERROR = 'remove comment error';
export const OPEN_BOOKMARK_STATUS = 'open bookmark status';
export const BOOKMARK_STATUS_DOWNLOADED = 'bookmark status downloaded';
export const BOOKMARK_COUNT_DOWNLOADED = 'bookmark count downloaded';
export const POST_BOOKMARK = 'post bookmark';
export const BOOKMARK_POSTED = 'bookmark posted';
export const POST_BOOKMARK_ERROR = 'post bookmark error';
export const OPEN_REVIEWS = 'open reviews';
export const REVIEWS_DOWNLOADED = 'reviews downloaded';
export const POST_REVIEW = 'post review';
export const REVIEW_POSTED = 'review posted';
export const POST_REVIEW_ERROR = 'post review error';
export const TOGGLE_THUMBUP = 'toggle thumbup';
export const TOGGLE_THUMBDOWN = 'toggle thumbdown';
export const THUMBDOWN_DONE = 'thumbdown done';
export const SELECT_REASON = 'select reason';
import {getInState} from '../helpers/composeReducer.js';

import {
    getFirstProblem as apiGetFirstProblem,
    getProblemByIdentifier,
    getSolutionsByIdentifier,
    parseIdentifier
} from '../helpers/api.js';

import {
    getProblemById,
    getSolutionById,
    postComment as apiPostComment,
    removeComment as apiRemoveComment,
    NO_ACCESS as MODEL_NO_ACCESS,
    LIMIT_EXCEEDED as MODEL_LIMIT_EXCEEDED,
    ACCOUNT_FLAGGED as MODEL_ACCOUNT_FLAGGED
} from '../modules/apiWrapper.js';

import {trigger} from '../helpers/events.js';

function getProblemHandler(dispatch, getState, identifier, p){
    p.then(function(problem){
        if (getInState(getState,'problem.identifier')!= identifier) return;
        dispatch({
            type : PROBLEM_OPENED,
            problem : problem
        });

        let ids = parseIdentifier(identifier);

        trigger('problemOpened', {
          ...ids,
          problemId: problem.problemId
        });
    }, function(e){
        if (getInState(getState,'problem.identifier')!= identifier) return;

        if (e.status == 404) {
            dispatch({
                type : NO_PROBLEM,
                identifier
            });
        }

        dispatch({
            type : UNKNOWN_ERROR,
            identifier,
            error : e
        });
    });
}

function getSolutionHandler(dispatch, getState, identifier, p){
    p.then(function(results){
        if (getInState(getState,'problem.identifier')!= identifier) return;

        let all_steps_open_status = getInState(getState,'ui.all_steps_open_status');
        dispatch({
            type: SOLUTIONS_DOWNLOADED,
            all_steps_open_status,
            ...results.solutionResult
        });

        // Incorporate bookmark and review dispatch here 
        const problems  = getInState(getState,'toc.problems','');

        dispatch({
            type : OPEN_BOOKMARK_STATUS,
            problem_identifier : identifier
        });

        if(problems[identifier]) {
            dispatch({
                type: BOOKMARK_STATUS_DOWNLOADED,
                problem_identifier : identifier
            });
        }

        dispatch({
            type: BOOKMARK_COUNT_DOWNLOADED,
            problem_identifier : identifier,
            ...results.bookmarkResult
        });

        dispatch({
            type : OPEN_REVIEWS,
            problem_identifier : identifier
        });

        dispatch({
            type: REVIEWS_DOWNLOADED,
            problem_identifier : identifier,
            review_box: results.reviewResult
        });
    }, function(error){
        switch(error.reason) {
            case MODEL_LIMIT_EXCEEDED:
                return dispatch({
                    type : LIMIT_EXCEEDED,
                    ...error
                });
            case MODEL_NO_ACCESS:
                return dispatch({
                    type : NO_ACCESS,
                    ...error
                });
            case MODEL_ACCOUNT_FLAGGED:
                return dispatch({
                    type : ACCOUNT_FLAGGED,
                    ...error
                });
        }

        dispatch({
            type : UNKNOWN_ERROR,
            error
        });
    });
}

function getProblem(identifier, dispatch, getState){
    const current_problem_identifier = getInState(getState,'problem.identifier');
    if (identifier == current_problem_identifier) {
        return;
    }

    dispatch({
        type : OPEN_PROBLEM,
        identifier
    });

    const store_id = getInState(getState,'app.id');
    const partner  = getInState(getState,'options.partner_name','');

    getProblemHandler(dispatch, getState, identifier, getProblemByIdentifier(store_id,identifier));

    getSolutionHandler(dispatch, getState, identifier, getSolutionsByIdentifier(store_id,identifier, partner));
}

export function openProblemById(id){
    return (dispatch, getState)=>{
        dispatch({
            type : OPEN_PROBLEM,
            identifier : id,
            single_solution : true
        });

        let isbn  = getInState(getState,'model.isbn13','');
        const partner  = getInState(getState,'options.partner_name','');
        let logger  = getInState(getState,'helpers.logger');
        let do_account_sharing  = getInState(getState,'options.do_account_sharing');
        let isModerator = getInState(getState, 'options.user.isModerator');

        getProblemHandler(dispatch, getState, id, getProblemById(id, partner, '', logger, isbn));
        getSolutionHandler(dispatch, getState, id, getSolutionById(isbn, id, '', partner, '', do_account_sharing, logger, isModerator));
    };
}

export function openProblem(name){
    return function(dispatch, getState){
        getProblem(name, dispatch, getState);
    };
}

export function getFirstProblem(chapter_name='') {
    return (dispatch, getState)=> {

        const store_id = getInState(getState,'app.id');

        return apiGetFirstProblem(store_id,chapter_name).then(function(problem){
            getProblem(problem, dispatch, getState);
        });
    };
}

/* istanbul ignore next */
export function toggleSolution(id){
    return {
        type : TOGGLE_SOLUTION,
        id : id
    };
}

/* istanbul ignore next */
export function openAllSolutions(){
	return {
		type : OPEN_ALL_SOLUTIONS
	};
}

/* istanbul ignore next */
export function closeAllSolutions(){
	return {
		type : CLOSE_ALL_SOLUTIONS
	};
}

/* istanbul ignore next */
export function toggleComments(id){
    return {
        type : TOGGLE_COMMENTS,
        id : id
    };
}

export function postComment(commentData){
    return (dispatch, getState) => {
        dispatch({
            type : POST_COMMENT,
            new_comment: commentData
        });

        const partner = getInState(getState,'options.partner_name','');
        let logger    = getInState(getState,'helpers.logger');

        apiPostComment(commentData, partner, '', logger).then(function(commentResult){
            dispatch({
                type : COMMENT_POSTED,
                new_comment : {
                    ...commentData,
                    ...commentResult
                }
            });
        }, function(error){
            dispatch({
                type : POST_COMMENT_ERROR,
                error
            });
        });
    };
}

export function removeComment(comment_id, solution_id, problem_id){
    return (dispatch, getState) => {
        dispatch({
            type : REMOVE_COMMENT,
            comment_id: comment_id,
            solution_id: solution_id
        });

        const partner = getInState(getState,'options.partner_name','');
        const app_id = getInState(getState,'app.id');

        apiRemoveComment(comment_id, solution_id, partner, app_id, problem_id).then(function(commentResult){
            dispatch({
                type : COMMENT_REMOVED,
                comment_id : comment_id
            });
        }, function(error){
            dispatch({
                type : REMOVE_COMMENT_ERROR,
                error
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/problem.action.js